import styled from 'styled-components'
import { AutoColumn } from 'components/Column'
import CurrencyInputPanel from 'components/CurrencyInputPanel'
import { DarkGreyCard } from 'components/Card'
import Input from 'components/NumericalInput'
import { ButtonPrimary } from 'components/Button'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px;
  min-width: 480px;
  transition: all ease 500ms;

  animation: fadeUp 0.5s ease-out;

  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    min-width: 400px;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
  min-width: 340px;
`};
`

export const ScrollablePage = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  animation: fadeUp 0.5s ease-out;

  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const FixedPreview = styled.div`
  position: relative;
  padding: 16px;
  width: 260px;
  height: fit-content;
  margin-top: 42px;
  background: ${({ theme }) => theme.bg0};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 12px;
  position: sticky;
  top: 64px;
`

export const DynamicSection = styled(AutoColumn)<{ disabled?: boolean }>`
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
  transition: all 0.3s ease;
`

export const CurrencyDropdown = styled(CurrencyInputPanel)`
  width: 48.5%;
`

export const PreviewCard = styled(DarkGreyCard)<{ disabled?: boolean }>`
  padding: 8px;
  border-radius: 12px;
  min-height: 40px;
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledInput = styled(Input)`
  background-color: ${({ theme }) => theme.bg0};
  text-align: left;
  font-size: 18px;
  width: 100%;
`

export const SmallButton = styled(ButtonPrimary)<{ active?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  background-color: ${({ theme, active }) => (active ? theme.primary1 : theme.bg3)};
  color: ${({ active }) => (active ? 'black' : 'white')}
  &:hover {
    color: black;
  }
  &:focus {
    color: black;
  }
  border-radius: 8px;
  padding: 4px 6px;
  width: 48%;
`

export const RowContainer = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: 1200px;

  @media (min-width: 768px) {
    padding: 16px;
    gap: 36px;
    grid-template-columns: calc(40% - 8px) calc(60% - 8px);
  }
`

export const CustomAppBody = styled.div<{ width: string; height?: string }>`
  position: relative;
  border: 1px solid #bec2da1a;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: rgba(14, 12, 21, 0.8);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 16px;
  margin-top: 1rem;
`

export const MobileStepperWrapper = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`

export const StepperWrapper = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`

// Stepper container
export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px;

  @media (min-width: 768px) {
    gap: 60px;
    grid-template-columns: calc(35% - 8px) calc(65% - 8px);
  }
`

// Individual step container
export const Step = styled.div<{ clickable: boolean }>`
  display: flex;
  align-items: flex-start;
  position: relative;
  align-items: center;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'not-allowed')};
`

export const StepperHeader = styled.div`
  border-radius: 16px;
  background: ${({ theme }) => theme.bg1};
  padding: 16px;
  h2 {
    font-size: 14px;
    font-size: 600;
  }
`

// Step number (circle)
export const StepNumber = styled.div<{ active: boolean }>`
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 50%;
  background-color: ${({ active, theme }) => (active ? theme.primary1 : 'rgba(255, 255, 255, 0.12)')};
  color: ${({ active }) => (active ? 'black' : 'white')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 15px;
  z-index: 1;
  font-weight: 500;
`

// Step content (title + description)
export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const StepTitle = styled.h3<{ active: boolean }>`
  font-size: 14px;
  font-weight: 500;
  font-family: unbounded;
  margin: 0;
  color: ${({ active, theme }) => (active ? 'white' : theme.text2)};
`

export const StepDescription = styled.p<{ active: boolean }>`
  font-size: 14px;
  color: ${({ active, theme }) => (active ? 'white' : theme.text2)};
  margin: 0;
`

// Vertical Line between steps
export const StepLine = styled.div`
  position: absolute;
  top: calc(30px + 50%);
  left: 15px;
  width: 2px;
  height: calc(100%);
  background-color: rgba(255, 255, 255, 0.12);
`

export const StepReview = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: ${({ theme }) => theme.bg2};
  border-radius: 14px;
  max-width: 100%;
  overflow: auto;

  .title {
    font-size: 16px;
    font-weight: 500;
    font-family: unbounded;
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .value {
    display: flex;
    align-items: center;
  }

  button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 14px;
    padding: 6px 8px;
    background: ${({ theme }) => theme.bg0};
    color: ${({ theme }) => theme.text2};

    &:hover {
      background: ${({ theme }) => theme.bg1};
    }
  }
`
